export default __webpack_public_path__ + "static/media/banners_raceweek_brasil_cochemoto_330x330.203e9ad7.jpg";